import { useEffect, useState, type ReactNode } from 'react';
import styles from './ViewportGate.module.css';

// Spec §0.5 + §0.11: minimum viewport is 1280 px. Below that, the entire app
// is replaced with a "use a larger screen" panel. The gate listens to
// resize events so the panel comes and goes as the user drags the window.
const MIN_WIDTH_PX = 1280;

function tooNarrow(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < MIN_WIDTH_PX;
}

export function ViewportGate({ children }: { children: ReactNode }) {
  const [narrow, setNarrow] = useState<boolean>(() => tooNarrow());

  useEffect(() => {
    function onResize(): void {
      setNarrow(tooNarrow());
    }
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (narrow) {
    return (
      <div className={styles.gate} role="alertdialog" aria-labelledby="ta-viewport-title">
        <div className={styles.panel}>
          <h1 id="ta-viewport-title" className={styles.title}>
            Please use a larger screen
          </h1>
          <p className={styles.message}>
            TechAithor is designed for screens at least {MIN_WIDTH_PX}px wide. Resize this
            window or switch to a desktop device to continue.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
